import React from 'react';

const Navigation: React.FC = () => {
    return (
        <nav id="nav">
            <ul>
                <li><a href="#intro" class="active">Our Moto</a></li>
                <li><a href="#first">Success Stories</a></li>
                <li><a href="#second">About Suyog</a></li>
                <li><a href="#cta">How to Join</a></li>
            </ul>
        </nav>
    );
}

export default Navigation;